<div class="tw-flex tw-justify-between tw-items-start tw-mb-1">
  <div [formGroup]="listFiltersService.filtersForm" class="tw-flex tw-justify-between tw-items-end">
    <ng-content></ng-content>
    <div *ngIf="listViewModeOptions" class="tw-flex tw-flex-col">
      <mat-label class="fixed-filter-label">{{
        'common.uiKit.monitoring.filters.toolbar.viewMode' | translate
      }}</mat-label>
      <mat-button-toggle-group class="mat-card-title__toggle" formControlName="viewMode">
        <mat-button-toggle *ngFor="let mode of listViewModeOptions" [value]="mode" aria-label="{{ mode }}">
          {{ 'common.uiKit.monitoring.filters.toolbar.' + (mode | camelCase) | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
</div>
